/**
 * Notifications Component
 * Displays toast-style notifications
 */

function Notifications({ notifications, onRemove }) {
	if (notifications.length === 0) {
		return null;
	}

	return wp.element.createElement('div', {
		className: 'or-fixed or-top-20 or-left-1/2 or-transform or--translate-x-1/2 or-z-50 or-space-y-2',
		style: { zIndex: 9999 }
	}, notifications.map(notification => 
		wp.element.createElement(NotificationItem, {
			key: notification.id,
			notification,
			onRemove
		})
	));
}

function NotificationItem({ notification, onRemove }) {
	const { id, message, type } = notification;
	
	const typeClasses = {
		success: 'or-bg-green-50 or-border-green-200 or-text-green-800',
		error: 'or-bg-red-50 or-border-red-200 or-text-red-800',
		warning: 'or-bg-yellow-50 or-border-yellow-200 or-text-yellow-800',
		info: 'or-bg-blue-50 or-border-blue-200 or-text-blue-800'
	};
	
	const icons = {
		success: '✅',
		error: '❌',
		warning: '⚠️',
		info: 'ℹ️'
	};

	return wp.element.createElement('div', {
		className: `or-rounded-lg or-border or-p-4 or-shadow-lg or-max-w-md or-animate-slide-up ${typeClasses[type] || typeClasses.info}`,
		style: { minWidth: '300px' }
	}, [
		wp.element.createElement('div', {
			key: 'content',
			className: 'or-flex or-items-start or-space-x-3'
		}, [
			wp.element.createElement('span', {
				key: 'icon',
				className: 'or-text-lg or-flex-shrink-0'
			}, icons[type] || icons.info),
			
			wp.element.createElement('div', {
				key: 'message',
				className: 'or-flex-1 or-text-sm or-font-medium'
			}, message),
			
			wp.element.createElement('button', {
				key: 'close',
				className: 'or-flex-shrink-0 or-text-gray-400 hover:or-text-gray-600 or-ml-2',
				onClick: () => onRemove(id),
				title: 'Dismiss'
			}, '×')
		])
	]);
}

export default Notifications;